import { ReactElement } from 'react'
import { Html } from '@react-three/drei'

interface Props {
  position: [number, number, number]
  color: string
  label: string
}

/** Small colored axis-name badge ("x"/"y") rendered at the end of an origin-gizmo axis. */
const AxisLabel = ({ position, color, label }: Props): ReactElement => (
  <Html position={position} center style={{ pointerEvents: 'none' }}>
    <span
      style={{
        padding: '2px 6px',
        background: color,
        color: '#fff',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      {label}
    </span>
  </Html>
)

export default AxisLabel
